var isServer = typeof window === 'undefined';

export default isServer;
